import { render } from "./addAgent.vue?vue&type=template&id=159ece84&scoped=true"
import script from "./addAgent.vue?vue&type=script&lang=js"
export * from "./addAgent.vue?vue&type=script&lang=js"

import "./addAgent.vue?vue&type=style&index=0&id=159ece84&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159ece84"]])

export default __exports__